import mainServerClient from "@/services/http/mainServerClient";
import { CheckSquareFilled, ExclamationCircleFilled, HeartFilled, StarFilled, TagFilled } from "@ant-design/icons";

export enum OrderMarkIcon {
    STAR = "STAR",
    TAG = "TAG",
    HEART = "HEART",
    CHECK = "CHECK",
    EXCLAMATION = "EXCLAMATION",
}

export function getAntdMarkIcon(icon: OrderMarkIcon) {
    switch (icon) {
        case OrderMarkIcon.STAR:
            return StarFilled;

        case OrderMarkIcon.TAG:
            return TagFilled;

        case OrderMarkIcon.HEART:
            return HeartFilled;

        case OrderMarkIcon.CHECK:
            return CheckSquareFilled;

        case OrderMarkIcon.EXCLAMATION:
            return ExclamationCircleFilled;
        default:
            return null;
    }
}

export interface OrderMark {
    id: number;

    color: string;

    companyId: number;

    icon: OrderMarkIcon;

    remark: string;

    shopId: number;

    /**需前端过滤删除的标记 */
    deleted: boolean;
}

/**
 * 获取当前公司的标记
 * @returns
 */
export function getOrderMarkList() {
    return mainServerClient.get<OrderMark[]>("/order/mark/list");
}

/**
 * 添加当前公司的标记
 */
export function addOrderMark(mark: Omit<OrderMark, "id" | "companyId" | "shopId" | "deleted">) {
    return mainServerClient.post<OrderMark>("/order/mark/add", mark);
}

/**
 * 更新当前公司的标记
 */
export function updateOrderMark(mark: Omit<OrderMark, "companyId" | "shopId" | "deleted">) {
    return mainServerClient.post<OrderMark>("/order/mark/update", mark);
}

/**
 * 删除当前公司的标记
 */
export function deleteOrderMark(id: number) {
    return mainServerClient.post<OrderMark>(`/order/mark/delete/${id}`);
}
